import { slbCart } from "./cart";
import { slbCommon } from "./common";
import { slbFooter } from "./footer";
import { slbHeader } from "./header";
import { slbCloudSolutionsPdp } from './cloud-solutions-pdp';
import { slbEdgeSolutionsPdp } from "./edge-solutions-pdp";
import { slbCheckout } from "./simulations";
import { slbServicesSolutionsPdp } from "./services-solutions-pdp";
import { slbOceanSolutionsPdp } from "./ocean-solutions-pdp";
import { SlbOnlinePayments } from "./online-payments";

export const en = {
    slbHeader,
    slbFooter,
    slbCommon,
    slbCart,
    slbCloudSolutionsPdp,
    slbEdgeSolutionsPdp,
    slbCheckout,
    slbServicesSolutionsPdp,
    slbOceanSolutionsPdp,
    SlbOnlinePayments
}
